import {API_BASE_URL} from '../GameConst.js';

export async function postAPI(path, parmas=[]){

    let body = '';
    let obj = {};
    parmas.forEach(param => {
        if(body.length){
            body += '&';
        }
        body += encodeURIComponent(param[0]) + '=' + encodeURIComponent(param[1]);
        obj[param[0]] = encodeURIComponent(param[1]);
    });
    const response = await fetch(`${API_BASE_URL}${path}`,
        {
            method: 'POST',
            mode: 'cors',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                // 'Content-Type': 'application/json',
            },
            body: body,
        }).catch(e => console.error(e));
    if(!response || !response.ok) return null;
    return response.json();
}

export async function getAPI(path){
    const response = await fetch(`${API_BASE_URL}${path}`,
        {
            method: 'GET',
            mode: 'cors',
            credentials: 'include',
        }).catch(e => console.error(e));
    if(!response || !response.ok) return null;
    return response.json();
}
